export default __webpack_public_path__ + "static/media/your_saved_hearing_loss.8aa9f66d.svg";